<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
    ></video>
  </div>
</template>

<script>
import videoJS from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'QVideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    accessToken: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      player: null,
      videoSrc: null,
    };
  },
  mounted() {
    if (this.accessToken) {
      videoJS.Vhs.xhr.beforeRequest = (options) => {
        options.headers = {
          Authorization: `Bearer ${this.accessToken}`,
        };
        return options;
      };
    }

    this.player = videoJS(
      this.$refs.videoPlayer,
      this.options,
      // function onPlayerReady() {
      //   // console.log('onPlayerReady', this);
      // },
    );
  },
  beforeUnmount() {
    // // console.log('destroying player');
    // // console.log(this.player);
    if (this.player) this.player.dispose();
  },
  methods: {
    async updateVideo(video) {
      this.player.src(video.sources);
    },
  },
};
</script>

<style scoped>
.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 56.25% !important;
}
</style>
